<div (click)="onClick()" style="color: blue;cursor: pointer;" *ngIf="linkVisible">{{value}}</div>
<div *ngIf="params.data.SubProcessTitle=='Total process cost'">{{params.value}}</div>
